import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 15l-4 -4h8l-4 4","key":"svg-1"}]]

const IconCircleCaretDown = createReactComponent('outline', 'circle-caret-down', 'CircleCaretDown', __iconNode);

export default IconCircleCaretDown;